export default {
    computed: {
        isOrderHistory() {
            return this.page.slug.en.current === 'orders'
        },
        isEditProfile() {
            return this.page.slug.en.current === 'profile'
        },
        isFavoriteProducts() {
            return this.page.slug.en.current === 'favorites'
        },
        isSupportPage() {
            return this.page.slug.en.current === 'support'
        },
        isC3News() {
            return this.page.slug.en.current === 'news'
        },
        isAddresses() {
            return this.page.slug.en.current === 'addresses'
        },
        isResetPassword() {
            return this.page.slug.en.current === 'password'
        },
        isDashboard() {
            return this.page.slug.en.current === 'dashboard'
        },
        isCustomerdetails() {
            return this.page.slug.en.current === 'company'
        },
        isSavedCarts() {
            return this.page.slug.en.current === 'carts'
        }
    }
}
